import { render, staticRenderFns } from "./FaceApiUsageLog.vue?vue&type=template&id=5677c35a&scoped=true"
import script from "./FaceApiUsageLog.vue?vue&type=script&lang=js"
export * from "./FaceApiUsageLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5677c35a",
  null
  
)

/* custom blocks */
import block0 from "./FaceApiUsageLog.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports